import MuiBadge, { BadgeProps } from '@mui/material/Badge';

function Badge(props: BadgeProps) {
  return <MuiBadge {...props} />;
}

export default Badge;
